import React from 'react';
import ThresholdContainer from '@components/noc-metric-panel/ThresholdV2';
import { ContentWrapper } from '../../styled';

function Content() {

  return (
    <ContentWrapper>
      <ThresholdContainer />
    </ContentWrapper>
  );
}

export default Content;
